import React, { FC, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider } from '@mui/material';
import QuotationElementBlockPrice from '../../QuotationsBlockShare/QuotationPriceElement/QuotationElementBlockPrice';
import { usePriceSummaryLoading } from '../../../context/priceSummaryContext/priceSummaryContext';
import { BookingConfigContext } from '../../../context/bookingConfigContext/bookingConfigContext';
import { Country } from '../../BookingWidget/bookingSteps.interface';

const PriceSummaryTax: FC = () => {
  const { t } = useTranslation();
  const { price, netPrice, taxGst, taxStampDuty } = usePriceSummaryLoading();
  const isSectionVisible = useMemo(
    () =>
      price > 0 &&
      netPrice !== undefined &&
      netPrice > 0 &&
      ((taxGst !== undefined && taxGst > 0) ||
        (taxStampDuty !== undefined && taxStampDuty > 0)),
    [price, netPrice, taxGst, taxStampDuty],
  );

  const country = useContext(BookingConfigContext).getCountry();
  const isStampDutyValidForCountry = useMemo(
    () => country?.country.toLowerCase() === 'au',
    [country],
  );

  return (
    isSectionVisible && (
      <>
        <Box className="gst-stampduty-container">
          <QuotationElementBlockPrice
            product={[
              {
                productName:
                  t('BOOKING.QUOTATION_SUMMARY_BLOCK.totalBeforeTax') || 'GST',
                amount: netPrice?.toString(),
              },
            ]}
          />
          <QuotationElementBlockPrice
            fontWeightLabel="normal"
            product={[
              {
                productName: t('BOOKING.QUOTATION_SUMMARY_BLOCK.gst') || 'GST',
                amount: (taxGst as number).toString(),
              },
            ]}
          />
          {taxStampDuty && isStampDutyValidForCountry && (
            <QuotationElementBlockPrice
              fontWeightLabel="normal"
              product={[
                {
                  productName:
                    t('BOOKING.QUOTATION_SUMMARY_BLOCK.stampDuty') ||
                    'Stamp Duty',
                  amount: (taxStampDuty as number).toString(),
                },
              ]}
            />
          )}
        </Box>
        <Divider sx={{ margin: 'var(--visual-summary-divider-margin)' }} />
      </>
    )
  );
};

export default PriceSummaryTax;
